export default "__VITE_ASSET__83d78a59__"